<template>
  <div class="main-layout sys-daily-page">
    <el-card class="box-inner">
      <c-title slot="header" title="系统日志" :back="false"></c-title>
      <el-card class="box-table box-daily" shadow="never">
      
          <c-table
            :data="pageData"
            :index="true"
            :tableColumns="tableColumns"
            :pagination="pageParams"
            @change="pageGet"
            v-loading="pageLoading"
          >
          </c-table>
       
      </el-card>
    </el-card>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import Configs from "./data/daily";
let mPage = MPage({
  pagePath: "/account/sys/log/list",
});
export default {
  mixins: [mPage],
  data() {
    let { searchItems, tableColumns } = Configs(this);
    return {
      searchItems,
      tableColumns,
    };
  },
  created() {},
  mounted() {},
  methods: {
    refresh() {
      this.pageParams = {};
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
  },
};
</script>
